import BaseSocket, { SocketOptions } from "../base";
import {
  CurrentDriverLocationResponseType,
  CurrentDriverType,
  CustomerStateDataType, NearbyDriversResponseType
} from "./types";
import { ETAType, LocationAndEtaDetailType, LocationObjectType } from "../base/types";
import locationTracker from "../location";

export type InitiateRideParamsType = {
  cardId: string,
  serviceType: 'TWD' | 'OWD',
  origin: { // comes from estimate api
    place: string,
    latitude: string,
    longitude: string,
  },
  destination: { // comes from estimate api
    place: string,
    latitude: string,
    longitude: string,
  },
  fareObj: { // comes from estimate api
    serviceType: 'TWD' | 'OWD',
    fare: number,
    farePerHr: number,
    time: number,
    driverShare: number,
    insurance: number,
    platformShare: number,
    forwardTime: number,
    backwardTime: number
  }
}

class CustomerSocket extends BaseSocket<CustomerStateDataType> {
  constructor(opts: SocketOptions) {
    super({ requestFrom: 'Customer', ...opts });
    this.on('serviceStatus', (data: CustomerStateDataType) => {
      this.setState(({ data: prevData }) => {
        let nextData = { ...data, nearbyDrivers: prevData.nearbyDrivers };
        let { ride, driver} = data;
        if (ride) {
          const { rideStatusCode } = ride;
          switch (rideStatusCode) {
            case 104:
            case 107:
            case 108:
              if(!driver) {
                driver = prevData.driver || undefined;
              }
              if(driver && prevData.driver) {
                if (!driver.location && prevData.driver.location) {
                  driver = { ...driver, location: prevData.driver.location };
                }
                if (!driver.eta && prevData.driver.eta) {
                  driver = { ...driver, eta: prevData.driver.eta };
                }
              }
              nextData.driver = driver;
            break;
          }
        }
        return { data: nextData };
      });
    });
    this.on('getDriverLocation', (data: CurrentDriverLocationResponseType) => {
      this.setState(({ data: prevData }) => {
        let nextData = { ...prevData };
        let { driver } = data;
        if (prevData.driver) {
          driver = { ...prevData.driver, ...driver };
        }
        nextData.driver = driver as CurrentDriverType;
        return { data: nextData };
      })
    })
    this.on('nearByDrivers', (data: NearbyDriversResponseType) => {
      if (data) {
        this.setState(({ data: prevData }) => {
          let nextData = { ...prevData };
          const { drivers } = data;
          nextData.nearbyDrivers = drivers;
          return { data: nextData };
        })
      }
    })
  }
  onLocationUpdate = ({ location }: LocationAndEtaDetailType) => {
    this.sendLocation(location);
  }
  sendLocation = (location: LocationObjectType) => {
    const { data } = this.state;
    const { userId, ride, driver } = data;
    const payload = {
      location,
      customerId: userId
    }
    if (ride) {
      switch (ride.rideStatusCode) {
        case 104:
        case 107:
          // @ts-ignore
          payload.driverId = (driver || {}).driverId;
      }
    }
    this.emit('customerLocation', payload)
  }
  initiateRide = (initiateRideParams: InitiateRideParamsType) => {
    if (!initiateRideParams.cardId) {
      this.throw('cardId is not given to initiateRide');
    }
    if (!initiateRideParams.serviceType) {
      this.throw('serviceType is not given to initiateRide');
    }
    if (!initiateRideParams.origin) {
      this.throw('origin is not given to initiateRide, get it from estimate API');
    }
    if (!initiateRideParams.destination) {
      this.throw('destination is not given to initiateRide, get it from estimate API');
    }
    if (!initiateRideParams.fareObj) {
      this.throw('fareObj is not given to initiateRide, get it from estimate API');
    }
    const { data } = this.state;
    const { userId, ride, unpaidRide } = data;
    if (ride && ride.rideStatusCode) {
      switch (ride.rideStatusCode) {
        case 100:
        case 104:
        case 107:
          this.throw('there\'s an ongoing ride, already');
      }
    }
    if (unpaidRide) {
      this.throw('there\'s an unpaid ride left!');
    }
    const payload = {
      token: this.token,
      rideRequest: {
        customerId: userId,
        ...initiateRideParams
      }
    };
    this.emit('initiateRide', payload);
  }
  cancelRide = (eta?: ETAType) => {
    const { data } = this.state;
    const { userId, ride, driver } = data;
    if (!ride) {
      this.throw('cannot cancel ride, because there\'s no ride!');
    }
    const payload = {
      token: this.token,
    // @ts-ignore
      rideId: ride.rideId,
      customer: {
        customerId: userId,
        location: locationTracker.location.location
      },
    }
    switch (ride?.rideStatusCode) {
      case 104:
        if (!eta) {
          this.throw('ETA is required when cancelling after driver is assigned');
        }
        // @ts-ignore
        payload.driver = {
        // @ts-ignore
          driverId: driver.driverId,
        // @ts-ignore
          location: driver.location
        }
        // @ts-ignore
        payload.eta = eta;
        break;
      case 100:
        break;
      default:
        this.throw('cannot cancel ride, already started or cancelled');
    }
    this.emit('cancelRide', payload);
  }
}

export default CustomerSocket;
